<template>
  <div class="t-context" ref="t_context">
    <div style="height:100%; width: 100%;" @contextmenu.prevent.stop="showInfo($event)">
      <slot></slot>
    </div>
    <div id="t_context_info_popup" class="t-context-info" v-if="show_info" :style="info_box_style" v-click-outside="hideInfo">
      <slot name="information"></slot>
    </div>
  </div>
</template>
<script>
  // import TIcon from '@/components/Taktify/TIcon.component.vue';
  export default {
    props: [],
    components: {
      // TIcon
    },
    data: () => ({
      show_info: false,
      info_box_style: {
        // top: '0px',
        left: '0px',
      }
    }),
    methods: {
      selectMenuItem(item){
        this.$emit('selectMenuItem', item);
        this.hideInfo();
      },
      showInfo(event){
        const parent = event.target;
        const parent_rect = parent.getBoundingClientRect();

        const info_left = event.clientX - parent_rect.left;
        // const info_top = event.clientY - parent_rect.top;
        const distance_to_right = window.innerWidth - (parent_rect.left + info_left);
        // const distance_to_bottom = window.innerHeight - (parent_rect.top + info_top);

        const required_width = 300;
        // const required_height = 150;

        // if there is not enough space on the right: move the menu left
        let left = event.clientX;
        
        if(distance_to_right < required_width){
          left = event.clientX - required_width;
        }

        // get all classes of the parent element
        if (parent.className.split !== undefined) {
          const classes = parent.className.split(' ');
          // if the class "standard-hover" is in the classes
          // then the parent element is the taktplan
          // and the scroll offset x of the taktplan has to be added to the left position
          if (classes.includes('standard-hover')) {
            // get the scroll offset x of element with id "taktplan"
            const scroll_offset = document.getElementById('taktplan').scrollLeft;
            left = left + scroll_offset;
          }
        }

        // if there is not enough space on the bottom: move the menu up
        // let top = event.clientY;
        // if(distance_to_bottom < required_height){
        //   top = event.clientY - required_height;
        // }

        this.show_info = true;
        // this.info_box_style.top = `${top}px`;
        this.info_box_style.left = `${left}px`;

      },
      hideInfo(){
        this.show_info = false;
      },
    }
  }
</script>
<style>

  .t-context {
    /* background-color: blue; */
  }

  .t-context-info {
    position: fixed;
    display: flex;
    margin-left: 1px;
    flex-direction: column;
    width: 300px;
    border-radius: 4px;
    /* border: 1px solid rgba(255, 255, 255, 0.3); */
    box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px 0px rgba(0, 0, 0, 0.14), 0px 1px 5px 0px rgba(0, 0, 0, 0.12);
    z-index: 1000;
    /* padding: 4px 4px; */
  }
 
</style>
